module.exports = __webpack_public_path__ + "static/media/puntoVenta.ff04b169.png";